import { render } from "./LinksToValidate.vue?vue&type=template&id=0f7c61a0"
import script from "./LinksToValidate.vue?vue&type=script&lang=js"
export * from "./LinksToValidate.vue?vue&type=script&lang=js"
script.render = render

export default script